"use client";

import Section from "@/components/static/Section";
import Headline from "@/components/static/Headline";
import Text from "@/components/static/Text";
import parse from "html-react-parser";
import Image from "next/image";
import Buttons from "@/components/static/Buttons";
import Button from "@/components/static/Button";
import { SectionProps, HeadlineProps, ImageProps, ButtonProps } from "@/lib/types";

type Content = {
    bgIMage: ImageProps;
    headline: HeadlineProps;
    text: string;
    image: ImageProps;
    settings: SectionProps;
    buttons: ButtonProps[];
};

export default function CTA_53({ content }: { content: Content }) {
    return (
        <Section dataComponent='CTA_53' settings={content.settings}>
            <div className='container'>
                <div className='relative flex flex-col items-center p-8 md:p-12 lg:p-28'>
                    <div className='text-center'>
                        <Headline
                            className='m-auto'
                            tag={content.headline.tag}
                            topline={content.headline.topline}
                        >
                            <div className='text-h1 text-center max-w-lg margin-auto text-white'>
                                {content.headline.title}
                            </div>
                        </Headline>
                        <Text className='prose md:text-md text-white'>{parse(content.text)}</Text>
                    </div>
                    <div className='mt-6 flex flex-wrap items-center justify-center gap-4 md:mt-8'>
                        {content.buttons && (
                            <Buttons className='buttons gap-x-8 mt-8'>
                                {content?.buttons?.map((button, index: number) => {
                                    return (
                                        <Button
                                            as='link'
                                            href={button?.link?.url}
                                            type={button?.type}
                                            key={index}
                                        >
                                            {button?.link?.title}
                                        </Button>
                                    );
                                })}
                            </Buttons>
                        )}
                    </div>
                    <div className='absolute inset-0 -z-10 rounded-[30px] overflow-hidden'>
                        <Image
                            src={content.bgIMage.url}
                            height={content.bgIMage.height}
                            width={content.bgIMage.width}
                            alt={content.bgIMage.alt}
                            className='size-full object-cover'
                        />
                        <div className='absolute inset-0 bg-[linear-gradient(0deg,rgba(0,0,0,0.39)_0%,rgba(0,0,0,0.39)_100%)]' />
                    </div>
                </div>
            </div>
        </Section>
    );
}
